import { RESET_ORDER } from 'components/orders/constants'

export default function ResetOrder() {
  return {
    type: RESET_ORDER,
  }
}
